export default __webpack_public_path__ + "static/media/s4img4.918936e6.webp";